import { TaskEdit } from '@client/components/tasks/TaskEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/workload-manager/tasks/list/add')({
    staticData: {
        metadata: {
            title: 'New task',
        },
        presentation: 'overlay',
    },
    component: TaskEdit,
});
